import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '@/lib/supabase/client'

// Minimalist login page for Galaxy Tab Active5
const Login = () => {
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault()
    setLoading(true)
    setError(null)

    try {
      const { error: signInError } = await supabase.auth.signInWithPassword({
        email,
        password,
      })

      if (signInError) throw signInError

      navigate('/company')
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to sign in')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="flex items-center justify-center min-h-screen p-6" style={{ backgroundColor: 'var(--bg-primary)' }}>
      <div className="bg-white rounded-xl shadow-lg p-12 w-full max-w-md border border-stone-200">
        {/* Logo */}
        <div className="flex justify-center mb-12">
          <img src="/wllogo.svg" alt="WLL Logo" className="h-16" />
        </div>

        {/* Login Form */}
        <form onSubmit={handleLogin} className="space-y-6">
          <div>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Username"
              required
              autoComplete="email"
              className="w-full px-4 py-3 text-base border-2 border-stone-300 rounded-lg focus:outline-none focus:border-[#1E3A5F] min-h-[56px] text-stone-800 placeholder:text-stone-400"
            />
          </div>

          <div>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
              required
              autoComplete="current-password"
              className="w-full px-4 py-3 text-base border-2 border-stone-300 rounded-lg focus:outline-none focus:border-[#1E3A5F] min-h-[56px] text-stone-800 placeholder:text-stone-400"
            />
          </div>

          {error && (
            <div className="bg-red-50 border-2 border-red-600 rounded-lg p-3">
              <p className="text-sm text-red-700 font-medium">{error}</p>
            </div>
          )}

          <button
            type="submit"
            disabled={loading || !email || !password}
            className="w-full bg-[#1E3A5F] hover:bg-[#152C4A] text-white font-semibold py-3 px-4 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed min-h-[56px] shadow-md"
          >
            {loading ? 'Signing In...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  )
}

export default Login

